import { styled } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { IconButton } from '@knowz/knowz-ui';

export const StyledCircularProgress = styled(CircularProgress)(() => ({
  position: 'absolute',
  top: '30%',
  left: '50%',
  bottom: 0,
  right: 0,
  transform: 'translate(-50%, -50%)!important',
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  width: `${theme.spacing(5)}!important`,
  height: `${theme.spacing(5)}!important`,
  fontSize: '0.6em',
  position: 'absolute',
  top: 0,
  right: 3,
}));
